import { render, staticRenderFns } from "./Privacidad.vue?vue&type=template&id=c2d570f2"
import script from "./Privacidad.vue?vue&type=script&lang=js"
export * from "./Privacidad.vue?vue&type=script&lang=js"
import style0 from "./Privacidad.vue?vue&type=style&index=0&id=c2d570f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports